<template>
  <div class="text-left">
    <div class="flex tete p-6 text-c5 text-c14" @click="activePosition = -1">
      <div class="w-1/2">
        Articles
      </div>
      <div class="w-1/2 flex">
        <div class="w-1/5 ml-4">
          Qté
        </div>
        <div class="w-1/3 ml-4">
          Prix unitaire
        </div>
        <div class="w-1/3 ml-4">
          Prix total
        </div>
        <div class="w-10 ml-4"/>
      </div>
    </div>

    <div class="diviser mt-2" />

    <div
        v-if="devis !== null && devis.articles !== undefined"
        class="mt-6"
    >
      <div class="w-full flex mt-6" v-for="(i, index) in devis.articles" :key="index" @click="open(index)">
        <div class="flex w-1/2 items-center">
          <icon
              v-if="i.type !== undefined && i.type === 'GLASS'"
            :data="icons.verre"
            height="40"
            width="40"
            class="mr-2 cursor-pointer"
            original
          />
          <icon
              v-if="i.product !== undefined && i.product.type === 'GLASS'"
              :data="icons.verre"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />
          <icon
              v-if="i.type !== undefined && i.type === 'FRAMES'"
              :data="icons.monture"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />
          <icon
              v-if="i.product !== undefined && i.product.type === 'FRAMES'"
              :data="icons.monture"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />
          <icon
              v-if="i.type !== undefined && i.type === 'ACCESSORY'"
              :data="icons.etuie"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />
          <icon
              v-if="i.product !== undefined && i.product.type === 'ACCESSORY'"
              :data="icons.etuie"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />
          <icon
              v-if="i.type !== undefined && i.type === 'SERVICE'"
              :data="icons.prestation"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />

          <icon
              v-if="i.type !== undefined && i.type === 'TREATMENT'"
              :data="icons.traitement"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />

          <icon
              v-if="i.product !== undefined &&  i.product.type === 'TREATMENT'"
              :data="icons.traitement"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />

          <icon
              v-if="i.product !== undefined && i.product.type === 'SERVICE'"
              :data="icons.prestation"
              height="40"
              width="40"
              class="mr-2 cursor-pointer"
              original
          />

          <div
              v-if="i.product !== undefined && i.product.type === 'GLASS'"
              class="ml-4 w-4/5"
          >
            <div class="text-c14 font-c5">{{ i.product.glassType }} | {{ i.product.ref }}</div>
            <div>
              <span class="font-c7 mr-1" v-if="i.meta !== undefined"> {{i.meta.oeil}}: </span>
              <span
                  class="font-c4 text-c11 text-90"
                  v-if="i.meta === undefined && devis.meta !== null && devis.meta.treatmentData !== undefined && devis.meta.treatmentData !== null"
              >
                Mat = {{i.product.glassMaterial}}; Indice = {{i.product.indice}}; S/couche = <span v-if="devis.meta.treatmentData.sousCouche !== undefined">{{devis.meta.treatmentData.sousCouche}};</span>
                T.Dur = {{devis.meta.treatmentData.dur}}; T.AR = {{devis.meta.treatmentData.ar}};
                Sph = {{devis.meta.treatmentData.sphere}}; Cyl = {{devis.meta.treatmentData.cylindre}}; Add = {{devis.meta.treatmentData.addition}};
                Axe = {{devis.meta.treatmentData.axe}}°; Diamètre = {{devis.meta.treatmentData.diametre}};

                <span v-if="devis.meta.treatmentData.color !== undefined && devis.meta.treatmentData.color !== ''">
                  Couleur = {{devis.meta.treatmentData.color}}
                </span>
              </span>

              <span
                  class="font-c4 text-c11 text-90 ml-2"
                  v-if="i.meta !== undefined && i.meta.treatmentData !== undefined && i.meta.treatmentData !== null"
              >
                Mat = {{i.product.glassMaterial}}; Indice = {{i.product.indice}}; S/couche = {{i.meta.treatmentData.sousCouche}};
                T.Dur = {{i.meta.treatmentData.dur}}; T.AR = {{i.meta.treatmentData.ar}};
                Sph = {{i.meta.treatmentData.sphere}}; Cyl = {{i.meta.treatmentData.cylindre}}; Add = {{i.meta.treatmentData.addition}};
                Axe = {{i.meta.treatmentData.axe}}°; Diamètre = {{i.meta.treatmentData.diametre}};

                <span v-if="i.meta.treatmentData.color !== undefined && i.meta.treatmentData.color !== ''">
                  Couleur = {{i.meta.treatmentData.color}}
                </span>
              </span>

              <span class="font-c4 text-c11 text-90" v-if="i.details !== null && i.details !== undefined">
                 Mat = {{i.product.glassMaterial}}; Indice = {{i.product.indice}}; S/couche = {{i.details.sousCouche}};
                T.Dur = {{i.details.dur}}; T.AR = {{i.details.ar}};
                Sph = {{i.details.sphere}}; Cyl = {{i.details.cylindre}}; Add = {{i.details.addition}};
                Axe = {{i.details.axe}}°; Diamètre = {{i.details.diametre}};
                <span v-if="i.details.color !== undefined && i.details.color !== ''">Couleur = {{i.details.color}}</span>
              </span>
            </div>
          </div>

<!--          <div-->
<!--              v-if="i.type !== undefined "-->
<!--              class="ml-4 w-4/5"-->
<!--          >-->
<!--            <div class="text-c14 font-c5">-->
<!--              {{ i.name }}-->
<!--            </div>-->
<!--          </div>-->

          <div
              v-if="i.product !== undefined && i.product.type !== 'GLASS'"
              class="ml-4 w-4/5"
          >
            <div class="text-c14 font-c5">
              {{ i.product.name }}
            </div>
          </div>
          <div
              v-if="i.type !== undefined && i.type !== 'GLASS'"
              class="ml-4 w-4/5"
          >
            <div class="text-c14 font-c5">
              {{ i.name }}
            </div>
          </div>
        </div>

        <div class="w-1/2 flex">
          <div class="w-1/5 ml-4">
            <div class="w-3/4">
              <bouton
                  v-if="i.quantity !== undefined && i.quantity > 0 && i.qte === undefined"
                  :label="'X' + i.quantity"
                  size="12px"
                  height="35px"
                  color="#828282"
                  background="#F5F5F5"
              />

              <bouton
                  v-if="i.qte !== undefined"
                  :label="'X' + i.qte"
                  size="12px"
                  height="35px"
                  color="#828282"
                  background="#F5F5F5"
              />
              <bouton
                  v-if="i.quantity === undefined && i.qte === undefined"
                  label="X 1"
                  size="12px"
                  height="35px"
                  color="#828282"
                  background="#F5F5F5"
              />

              <selectFiltre :option="optionQte" @info="retourQte" value="" size="12px" v-if="activePosition === index"/>
            </div>
          </div>

          <div class="w-1/3">
              <bouton
                  v-if="i.amount === undefined"
                  :label="i.prix.toLocaleString()"
                  size="14px"
                  height="35px"
                  color="#000"
                  background="#F5F5F5"
              />
            <bouton
                v-if="i.amount !== undefined"
                :label="i.amount.toLocaleString()"
                size="14px"
                height="35px"
                color="#000"
                background="#F5F5F5"
            />
          </div>

          <div class="w-1/3 ml-4">
              <bouton
                  :label="calcule(i)"
                  size="14px"
                  height="35px"
                  color="#000"
                  background="#F5F5F5"
              />
          </div>

          <div class="w-10 ml-4">
            <icon
                :data="icons.remove"
                height="20"
                width="20"
                class="cursor-pointer"
                @click="remove(index)"
                original
            />
          </div>

        </div>
      </div>
    </div>

    <div
        v-if="devis === null || devis.articles === undefined"
        class="mt-20"
    >
      <bouton
        label="Ajouter un article"
        border="0.5px dashed #5138EE"
        size="14px"
        color="#5138EE"
        background="#EFF4FF"
        @oga="retourAdd"
      />
    </div>

    <diviser
      height="1.8px"
      color="#5138EE"
      class="mt-10"
    />
  </div>
</template>

<script>
import bouton from '../../helper/add/button'
import diviser from '../../helper/add/divider'
import verre from '../../../assets/icons/verre.svg'
import prestation from '../../../assets/icons/prestation.svg'
import monture from '../../../assets/icons/monture.svg'
import etuie from '../../../assets/icons/etuie.svg'
import selectFiltre from '../../helper/form/selectFiltre'
import remove from '../../../assets/icons/remove.svg'
import traitement from '../../../assets/icons/surface.svg'
import apiroutes from '../../../router/api-routes'
import http from '../../../plugins/https'

export default {
  name: "Index",

  components: {
    bouton,
    diviser,
    selectFiltre
  },

  props: {

  },

  data () {
    return {
      icons: {
        verre,
        monture,
        etuie,
        prestation,
        remove,
        traitement
      },
      devis: null,
      optionQte: ['X 1', 'X 2', 'X 3', 'X 4', 'X 5'],
      activePosition: -1,
      charge: false
    }
  },

  created () {
    this.devis = this.$store.getters.update
  },

  methods: {
    retourAdd () {
      this.$router.push('/panier')
    },

    retourQte (answer) {
      this.devis.articles[this.activePosition].quantity = answer.replace('X ', '')
      // this.$store.dispatch('saveQuote', this.devis)
      this.open(this.activePosition)
    },

    open (index) {
      // if (this.activePosition !== index) {
      //   this.activePosition = index
      // } else {
      //   this.activePosition = -1
      // }
      console.log(index)
    },

    calcule (u) {
      let amount = 0
      if (u.amount !== undefined) {
        amount = amount + (parseInt(u.amount) * parseInt(u.quantity))
      } else {
        amount = amount + (parseInt(u.prix) * parseInt(u.qte))
      }
      return amount.toLocaleString()
    },

    remove (index) {
      this.charge = true
      http.delete(apiroutes.baseURL + apiroutes.deleteArticle + '?id='+ this.devis.articles[index].id)
          .then(response => {
            this.devis.articles.splice(index, 1)
            console.log(response)
            this.charge = false
          })
          .catch(error => {
            this.devis.articles.splice(index, 1)
            this.charge = false
            console.log(error)
          })

    }
  }
}
</script>

<style lang="scss" scoped>
.svg-icon {
  fill: white;
}
.diviser{
  height: 1px;
  background-color: #DCDCE4;
}
.tete{
  color: #5138EE;
  background: linear-gradient(180deg, #EFF4FF 0%, rgba(239, 244, 255, 0) 100%);
  border-radius: 10px;
  border-top: 5px solid #5138EE;
}

</style>
